import React from "react";
import ReactGA from "react-ga";
import logo from "../../images/logo.png";
import DarkModeToggle from "../utils/DarkModeToggle";
import {
  SIGN_OUT,
  RESOLVE_LOCAL_AUTH_STATE,
  RESOLVE_LOCAL_USER_STATE,
} from "../auth/AuthActions";

class NavigationBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: RESOLVE_LOCAL_AUTH_STATE(),
      user: RESOLVE_LOCAL_USER_STATE(),
      globalSearch: "",
    };
  }

  componentDidMount() {
    ReactGA.initialize("UA-54935029-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  handleGlobalSearchChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleGlobalSearchSubmit = (e) => {
    e.preventDefault();
    window.location = `/search/?search=${this.state.globalSearch}`;
  };

  handleSignOut = () => {
    const token = this.state.auth.token;
    SIGN_OUT(token);
  };

  render() {
    const { auth, globalSearch } = this.state;
    const is_authenticated = auth.is_authenticated === "true";

    return (
      <nav className="navbar navbar-expand-lg navbar-light i7-navbar">
        <div className="container">
          <a className="navbar-brand" href="/" aria-label="Inertia7 Home">
            <img
              src={logo}
              alt="Inertia7"
              width="40"
              height="34"
              className="d-inline-block align-top"
            />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            {/* Left: Search */}
            <form onSubmit={this.handleGlobalSearchSubmit} className="d-flex flex-grow-1 mx-lg-4 my-2 my-lg-0">
              <input
                id="globalSearch"
                name="globalSearch"
                value={globalSearch}
                onChange={this.handleGlobalSearchChange}
                className="form-control me-3"
                type="search"
                placeholder="Search"
                aria-label="Search"
              />
              <button className="btn btn-teal" type="submit">Search</button>
            </form>

            {/* Right: Nav items */}
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              {is_authenticated && (
                <li className="nav-item">
                  <a className="nav-link" href="/home">Home</a>
                </li>
              )}

              {is_authenticated && (
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="/projects/new"
                    style={{ color: "var(--brand-dark)", fontWeight: 700 }}
                  >
                    + New Project
                  </a>
                </li>
              )}

              {is_authenticated && (
                <li className="nav-item">
                  <a className="nav-link" href="/settings">Settings</a>
                </li>
              )}

              {is_authenticated && (
                <li className="nav-item">
                  <a className="nav-link" href="/" onClick={this.handleSignOut}>
                    Sign Out
                  </a>
                </li>
              )}

              {!is_authenticated && (
                <li className="nav-item">
                  <a className="nav-link" href="/accounts/signin">Sign In</a>
                </li>
              )}

              {!is_authenticated && (
                <li className="nav-item">
                  <a className="nav-link" href="/accounts/register">Join! It&apos;s free!</a>
                </li>
              )}
              
              {/* Dark Mode Toggle - Far Right */}
              <li className="nav-item d-flex align-items-center ms-2">
                <DarkModeToggle />
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default NavigationBar;
